import React, { useState, Fragment } from 'react';
import { withWizard } from 'react-albus';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import styled, { keyframes } from 'styled-components';
import { OPTIONS_ANIMATION_DURATION } from '../weightLossPrequalification/components/constants';
import theme from '../../styles/theme';
import { isMobile } from 'react-device-detect';

const Btn = styled(Button)`
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  border: 1px solid #ffffff;
  font-size: 14px;
  font-weight: 300;

  transition: background 300ms ease-in;
  &.selected {
    background: #e7f0ff;
    border: 1px solid #354e79;
    box-sizing: border-box;
  }
`;
const SelectedMarkerOut = styled(Flex)`
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;

  background: #ffffff;
  border: 2px solid #354e79;
  border-radius: 12px;
  margin-right: 12px;
`;
const SelectedMarkerIn = styled(Flex)`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #354e79;
  transition: all 450ms ease-in;
`;
const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;
const Option = styled(Flex)`
  margin-bottom: 12px;
  flex: 1;
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;
const Rect = styled.rect`
  transition: all var(0.3s) linear;
`;
const CheckboxWrap = styled(Flex)`
  border-color: rgba(0, 0, 0, 0.19);
  border-width: 2px;
  border-radius: 50%;
  border-style: solid;
  transition: all var(0.3s) linear;
  overflow: hidden;
  height: 20px;
  width: 20px;
`;
const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

const LegalSex = ({ state, id, onChange, onContinue }) => {
  return (
    <Flex flex={1} flexDirection="column">
      <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} mb={4}>
        What is your legal sex?
      </Text>
      <Flex my={3} flexDirection={'column'}>
        {[{ label: 'Female', value: 'F' }, { label: 'Male', value: 'M' }].map((x, i) => {
          const isSelected = (state || {})['legalSex'] === x.value;
          return (
            <Option
              key={x.value}
              style={{
                animationDelay: `${1 + i * OPTIONS_ANIMATION_DURATION}s`,
              }}
            >
              <Flex flexDirection={'column'} flex={1}>
                <Flex
                  mb={3}
                  style={{
                    cursor: 'pointer',
                    overflow: 'hidden',
                    width: '100%',
                    borderRadius: '12px',
                    border: `${isSelected ? '2px solid rgb(249, 163, 148)' : '1px solid rgba(0, 0, 0, 0.15)'}`,
                    padding: isMobile ? (isSelected ? '14px 18px' : '15px 19px') : isSelected ? '18px' : '19px',
                    backgroundColor: isSelected ? 'rgba(255,255,255,0.43)' : 'transparent',
                    flex: 1,
                  }}
                  onClick={() => {
                    onChange('legalSex', x.value);
                  }}
                >
                  <CheckboxWrap style={{ borderColor: isSelected ? theme.color.pink : '', alignSelf: 'baseline' }}>
                    <Flex
                      flex={1}
                      style={{ background: isSelected ? theme.color.pink : 'transparent', borderRadius: '50%', border: isSelected ? '2px solid #fdf5f2' : 'transparent', overflow: 'hidden' }}
                    />
                  </CheckboxWrap>
                  <Flex flexDirection={'column'} ml={3} flex={1}>
                    <Text fontWeight={500} fontSize={isMobile ? '14px' : ''}>
                      {x.label}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Option>
          );
        })}
      </Flex>

      <FootNote
        mb={4}
        alignItems={'center'}
        style={{
          animationDelay: `${1 + 2 * OPTIONS_ANIMATION_DURATION}s`,
        }}
      >
        <Button mt={3} variant="primary" width={[1 / 2, 1 / 3]} type="submit" onClick={onContinue} disabled={!state['legalSex']}>
          Continue
        </Button>
        <Text
          textAlign="center"
          mt={3}
          mb={4}
          style={{ color: '#0075FF', textDecoration: 'underline' }}
          width={[1 / 2, 1 / 3]}
          onClick={() => {
            onChange('legalSex', null);
            onContinue();
          }}
        >
          Skip
        </Text>
        {/* </Flex> */}
      </FootNote>
    </Flex>
  );
};

export default withWizard(LegalSex);
